import { makeStyles } from "@material-ui/styles";
import statusSettings from "../../Config";
import BatteryStdIcon from "@material-ui/icons/BatteryStd";
import React from "react";

const BATTERY_INDICATOR_SIZE = 75

const containerSize = `${BATTERY_INDICATOR_SIZE}px`,
    batteryIconSize = `${BATTERY_INDICATOR_SIZE * 0.4}px`

export default makeStyles(theme => ({
    main: {
        marginTop: theme.spacing(1)
    },
    currentStatus: {
        margin: `${theme.spacing(3)} 0`,
        "& b": {
            fontSize: "3em"
        }
    },
    batteryIndicator: {
        width: containerSize,
        height: containerSize,
        display: "flex",
        margin: "auto",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        "& > svg": {
            width: batteryIconSize,
            height: batteryIconSize
        },
        "& > div": {
            position: "absolute",
            top: "0",
            left: "0",
            bottom: "0",
            right: "0"
        }
    },
    properties: {
        "& b":{
            fontSize: "1.5em"
        },
        "& p": {
            color: theme.palette.text.disabled,
            marginTop: 0
        }
    },
    modeHeading: {
        color: theme.palette.text.disabled
    },
    propertyTable: {
        fontWeight: "500",
        fontSize: "1.3em",
        "& b":{
            color: theme.palette.text.disabled
        }
    },
    battery:{
        textAlign: "center"
    },
    [theme.breakpoints.down("sm")]:{
        battery: {
            textAlign: "left"
        },
        batteryIndicator: {
            margin: "0 auto 0 0",
        }
    }
}))